import { FC } from 'react';

import { formatTime, isSignificantlyDelayedOrAhead } from '@/utils/dateUtils';
import { isZelfdeDienstregelpunt } from '@/utils/dienstregelpunt';

import styles from './MwdTooltipAankomstRow.module.css';

const STRINGS = {
  TOT: 'Tot: ',
  NAAR: 'Naar: ',
  AANKOMST: 'Aankomst: ',
  DRGL_WIJZIGING: ' (drgl wijziging)',
};

type MwdTooltipAankomstRowProps = {
  oorspronkelijkePlanTijd: Date;
  actuelePlanTijd: Date;
  uitvoeringsTijd: Date;
  dienstregelpuntVan?: string;
  dienstregelpuntNaar?: string;
  isOvergang?: boolean;
};

const MwdTooltipAankomstRow: FC<MwdTooltipAankomstRowProps> = ({
  oorspronkelijkePlanTijd,
  actuelePlanTijd,
  uitvoeringsTijd,
  dienstregelpuntVan,
  dienstregelpuntNaar,
  isOvergang = false,
}) => {
  const isZelfdePunt = isZelfdeDienstregelpunt(dienstregelpuntVan, dienstregelpuntNaar);
  const isUitvoeringAfwijkend = isSignificantlyDelayedOrAhead(oorspronkelijkePlanTijd, uitvoeringsTijd);
  const isDienstregelingGewijzigd = isSignificantlyDelayedOrAhead(oorspronkelijkePlanTijd, actuelePlanTijd);

  let prefix = isZelfdePunt ? STRINGS.TOT : STRINGS.NAAR;
  if (isOvergang) prefix = ' ';

  return (
    <div className={styles.row} data-testid='mwd-overgang-tooltip-aankomst'>
      {prefix}
      {isOvergang && STRINGS.AANKOMST}{' '}
      <span className={isUitvoeringAfwijkend ? styles.strikeThrough : undefined}>
        {formatTime(oorspronkelijkePlanTijd)}
      </span>{' '}
      {isUitvoeringAfwijkend && (
        <span className={oorspronkelijkePlanTijd < uitvoeringsTijd ? styles.delayed : styles.ahead}>
          <strong>{formatTime(uitvoeringsTijd)}</strong>
        </span>
      )}
      {isZelfdePunt ? '' : ` ${dienstregelpuntNaar}`}
      {isDienstregelingGewijzigd ? STRINGS.DRGL_WIJZIGING : ''}
    </div>
  );
};

export default MwdTooltipAankomstRow;
